export default __webpack_public_path__ + "assets/57d03c2b026255aca4368142e9fae7d8.webp";